
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'WideIconCtaBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/WideIconCtaBanner/WideIconCtaBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'WhichUspBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/WhichUspBanner/WhichUspBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'VisitConfirmed',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/VisitConfirmed/VisitConfirmed.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Video',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Video/Video.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'UspBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/UspBanner/UspBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TrustpilotSummary',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TrustpilotSummary/TrustpilotSummary.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TrustpilotSingleCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TrustpilotSingleCarousel/TrustpilotSingleCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TrustpilotEmbed',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TrustpilotEmbed/TrustpilotEmbed.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TrustpilotCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TrustpilotCarousel/TrustpilotCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TabbedHotspot',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TabbedHotspot/TabbedHotspot.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BookingForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SurveyBookingForm/BookingForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'StatCards',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/StatCards/StatCards.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SquareSignposts',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SquareSignposts/SquareSignposts.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SplitSignpostCards',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SplitSignpostCards/SplitSignpostCards.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SplitContent',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SplitContent/SplitContent.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SignpostCardsSection',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SignpostCardsSection/SignpostCardsSection.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ShowroomDetailsMap',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ShowroomDetailsMap/ShowroomDetailsMap.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ShowroomDirectory',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ShowroomDirectory/ShowroomDirectory.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SearchResultsList',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SearchResultsList/SearchResultsList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RoomCardsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RoomCardsCarousel/RoomCardsCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RealRoomsListing',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RealRoomsListing/RealRoomsListing.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RealRoomsShowcase',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RealRoomShowcase/RealRoomsShowcase.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RealRoomsCards',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RealRoomsCards/RealRoomsCards.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RealRoomCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RealRoomCarousel/RealRoomCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RangePreview',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RangePreview/RangePreview.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RangeListing',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RangeListing/RangeListing.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RangeDetailGallery',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RangeDetailGallery/RangeDetailGallery.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RangeCardsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RangeCardsCarousel/RangeCardsCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'QuotesList',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/QuotesList/QuotesList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RangeCardsOffersCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/RangeCardsOffersCarousel/RangeCardsOffersCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'QuotePaymentTypes',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/QuotePaymentTypes/QuotePaymentTypes.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'PriceComparison',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/PriceComparison/PriceComparison.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'PostPaymentMessage',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/PostPaymentMessage/PostPaymentMessage.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'PopUp',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/PopUp/PopUp.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PaymentForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/PaymentForm/PaymentForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'OptionsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/OptionsCarousel/OptionsCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'NearestStore',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/NearestStore/NearestStore.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'MediaGalleryWidget',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/MediaGalleryWidget/MediaGalleryWidget.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MediaCollage',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/MediaCollage/MediaCollage.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'LocationMap',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/LocationMap/LocationMap.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Issuelist',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Issuelist/Issuelist.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'InspirationCards',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/InspirationCards/InspirationCards.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'InnerPageHeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/InnerPageHeroBanner/InnerPageHeroBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ImageSpotlight',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ImageSpotlight/ImageSpotlight.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'IconCtaBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/IconCtaBanner/IconCtaBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'IconCardsListing',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/IconCardsListing/IconCardsListing.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HtmlSiteMap',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/HtmlSiteMap/HtmlSiteMap.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/HeroBanner/HeroBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Header',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Header/Header.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'IconCardsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/IconCardsCarousel/IconCardsCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'GatedContentForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/GatedContentForm/GatedContentForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Footer',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Footer/Footer.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FloatingCta',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FloatingCta/FloatingCta.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FindNearestShowroom',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FindNearestShowroom/FindNearestShowroom.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FinanceCalculator',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FinanceCalculator/FinanceCalculator.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FeatureSpotlight',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FeatureSpotlight/FeatureSpotlight.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FeaturedBlogArticles',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FeaturedBlogArticles/FeaturedBlogArticles.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FeaturedRealRooms',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FeaturedRealRooms/FeaturedRealRooms.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'EmbeddedPdfLink',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/EmbeddedPdfLink/EmbeddedPdfLink.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'DesignVisitForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/DesignVisitForm/DesignVisitForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CtaSeparator',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/CtaSeparator/CtaSeparator.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContentCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ContentCarousel/ContentCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CostCalculator',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/CostCalculator/CostCalculator.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContentCardList',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ContentCardList/ContentCardList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CompetitorComparison',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/CompetitorComparison/CompetitorComparison.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CategoryCards',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/CategoryCards/CategoryCards.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'BrochureRequested',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/BrochureRequested/BrochureRequested.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BlogListing',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/BlogListing/BlogListing.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BespokeAccessorySelector',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/BespokeAccessorySelector/BespokeAccessorySelector.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BedroomStorageCardsList',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/BedroomStorageCardsList/BedroomStorageCardsList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ArticleShowcase',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ArticleShowcase/ArticleShowcase.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ArticleDetailPageHeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ArticleDetailPageHeroBanner/ArticleDetailPageHeroBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Accordion',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Accordion/Accordion.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccessoryExplorer',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/AccessoryExplorer/AccessoryExplorer.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ToastContainer',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/ToastContainer/ToastContainer.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SectionDivider',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/SectionDivider/SectionDivider.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SaleBanner',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/SalesBanner/SaleBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Breadcrumb',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/Breadcrumb/Breadcrumb.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RequestAFreeBrochureForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Forms/RequestAFreeBrochureForm/RequestAFreeBrochureForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'EmbeddedForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Forms/EmbeddedForm/EmbeddedForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContactForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Forms/ContactForm/ContactForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccountContactForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Forms/AccountContactForm/AccountContactForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TestimonialCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ContentCarousel/Testimonial/TestimonialCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'MyDetailsForm',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/MyDetailsForm/MyDetailsForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ModalBreakdown',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/ModalBreakdown/ModalBreakdown.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ForgottenPassword',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/ForgottenPassword/ForgottenPassword.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Login',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/Login/Login.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HoldingPageMessage',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/HoldingPageMessage/HoldingPageMessage.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ConfirmNewPassword',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/ConfirmNewPassword/ConfirmNewPassword.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccountOrderList',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/AccountOrderList/AccountOrderList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccountOrderLines',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/AccountOrderLines/AccountOrderLines.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccountHelpCentre',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Account/AccountHelpCentre/AccountHelpCentre.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'MediaEmbed',
  import: (): Promise<any> => import('C:/agent/_work/14009/s/Hammonds.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/Misc/MediaEmbed/MediaEmbed.client'),
  config: {
  hydrate: 'in-view',
},
} 
];
  